/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
import { useCallback, useState } from 'react'
import { SectionPageLayout } from '@/components/layout'
import { RegisterCodesTable } from './components/register-codes-table'
import { RegisterCodesCreateButton } from './components/register-codes-create-button'

export function RegisterCodes() {
  const [refreshKey, setRefreshKey] = useState(0)

  const handleSuccess = useCallback(() => {
    setRefreshKey((prev) => prev + 1)
  }, [])

  return (
    <SectionPageLayout>
      <SectionPageLayout.Title>
        注册码管理
      </SectionPageLayout.Title>
      <SectionPageLayout.Description>
        管理用户注册使用的注册码
      </SectionPageLayout.Description>
      <SectionPageLayout.Actions>
        <RegisterCodesCreateButton onSuccess={handleSuccess} />
      </SectionPageLayout.Actions>
      <SectionPageLayout.Content>
        <RegisterCodesTable key={refreshKey} />
      </SectionPageLayout.Content>
    </SectionPageLayout>
  )
}
